import utagLinkGeneric from './utagLinkGeneric';

function utagLinkPDP (eventCategory = 'PDP') {

	return ({ eventAction, eventLabel = '', nonInteraction = 0 }) => {

		utagLinkGeneric({
			eventCategory,
			eventAction,
			eventLabel,
			nonInteraction
		});

	};

}

export default utagLinkPDP;
